export interface ProductTypeDictionaryEntry {
  name: string;
  description: string;
  [key: string]: unknown;
}

export type ProductTypeDictionary = Record<string, ProductTypeDictionaryEntry>;

/**
 * Get product type description from dictionary by product type name
 */
export const getProductTypeDescription = (
  productType: string,
  dictionary: ProductTypeDictionary,
): string => {
  const entry = Object.values(dictionary).find(
    (item) => item.name === productType,
  );

  return entry ? entry.description : productType;
};
